import { baseAPI } from "../baseApi";

export const roadBedLayersApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение всех типов покрытий для базы с их протяженностью
        fetchPavementGroupsDict: builder.query<any, any>({
            query: () => ({
                url: `Objects/PavementGroups`
            })
        }),
    })
})

export const {
    useFetchPavementGroupsDictQuery,
} = roadBedLayersApiSlice